import { Chart, Plugin } from "chart.js";

const isFiniteNumber = (value: unknown): value is number => typeof value === "number" && Number.isFinite(value);
const isNonEmptyString = (value: unknown): value is string => typeof value === "string" && value.length > 0;

const createSolidGradient = (
  ctx: CanvasRenderingContext2D,
  fromY: number,
  toY: number,
  startColor: unknown,
  endColor: unknown = startColor,
) => {
  if (!isNonEmptyString(startColor) || !isNonEmptyString(endColor)) {
    return null;
  }

  const gradient = ctx.createLinearGradient(0, fromY, 0, toY);
  gradient.addColorStop(0, startColor);
  gradient.addColorStop(1, endColor);

  return gradient;
};

export const AlarmLevel: Plugin = {
  id: "alarmLevel",
  beforeDraw: (chart: Chart, args: { cancelable: true }, options: any) => {
    if (!options || options === false) {
      return;
    }

    const {
      ctx,
      chartArea: { left, top, right, bottom },
      scales,
    } = chart;

    if ((chart.config as any).type === "radar") {
      return;
    }

    const y = scales[options.yAxisID || "y"];

    if (!y) {
      console.error("Y scale is not defined");
      return;
    }

    const width = right - left;
    const height = bottom - top;

    const level2Y = y.getPixelForValue(options.level2);
    const level3Y = y.getPixelForValue(options.level3);
    const level4Y = y.getPixelForValue(options.level4);

    ctx.save();
    ctx.beginPath();
    ctx.rect(left, top, width, height);
    ctx.clip();
    ctx.globalAlpha = 0.8;
    if (isFiniteNumber(level2Y)) {
      const gradient = createSolidGradient(ctx, level2Y, bottom, options.level2Color);

      if (!gradient) {
        ctx.restore();
        return;
      }

      ctx.fillStyle = gradient;
      ctx.fillRect(left, level2Y, width, bottom - level2Y);
    } else if (isFiniteNumber(level3Y) && level3Y > 0) {
      const gradient = createSolidGradient(ctx, level3Y, bottom, options.level2Color);

      if (!gradient) {
        ctx.restore();
        return;
      }

      ctx.fillStyle = gradient;
      ctx.fillRect(left, level3Y, width, bottom - level3Y);
    } else if (isFiniteNumber(level4Y) && level4Y > 0) {
      const gradient = createSolidGradient(ctx, level4Y, bottom, options.level2Color, "rgba(106, 205, 97, 0)");

      if (!gradient) {
        ctx.restore();
        return;
      }

      ctx.fillStyle = gradient;
      ctx.fillRect(left, level4Y, width, bottom - level4Y);
    } else {
      const gradient = createSolidGradient(ctx, top, bottom, options.level2Color);

      if (!gradient) {
        ctx.restore();
        return;
      }

      ctx.fillStyle = gradient;
      ctx.fillRect(left, top, width, height);
    }

    if (isFiniteNumber(level3Y) && level3Y > 0) {
      const gradient = createSolidGradient(ctx, level4Y || top, level3Y, options.level3Color);

      if (gradient) {
        ctx.fillStyle = gradient;
        ctx.fillRect(left, level3Y, width, (level4Y || top) - level3Y);
      }
    } else if (isFiniteNumber(level4Y) && level4Y > 0) {
      const gradient = createSolidGradient(ctx, top, level4Y, options.level3Color);

      if (gradient) {
        ctx.fillStyle = gradient;
        ctx.fillRect(left, level4Y, width, (level2Y || top) - level4Y);
      }
    }

    if (isFiniteNumber(level4Y) && level4Y > 0) {
      const gradient = createSolidGradient(ctx, top, level4Y, options.level4Color);

      if (gradient) {
        ctx.fillStyle = gradient;
        ctx.fillRect(left, level4Y, width, top - level4Y);
      }
    }
    ctx.restore();
  },
};
